"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreateDateOfEvaluationItem = exports.checkEditable = exports.getEvaluationItems = exports.getEvaluationItem = exports.getBases = exports.getContents = exports.getContentsWithIds = exports.getEvaluationStates = exports.getContent = exports.getBase = void 0;
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var PRC_1 = require("@cck/common/dist/data/PRC");
var Staff_1 = require("@cck/common/dist/data/Staff");
var lodash_1 = __importDefault(require("lodash"));
var firebase = __importStar(require("../firebase/fbase"));
var Admin = __importStar(require("../utils/Admin"));
var EvaluationUtils_1 = require("./EvaluationUtils");
// TODO(sangmuk): Remove export after moving from frontend evaluation.js.
function getBase(evalType, name) {
    return __awaiter(this, void 0, void 0, function () {
        var targetCollectionName, docData, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(name !== '' && name !== '신규')) return [3 /*break*/, 2];
                    targetCollectionName = Evaluation.getKoEvaluation(evalType);
                    return [4 /*yield*/, firebase.dbService.collection(targetCollectionName).doc(name).get()];
                case 1:
                    docData = _a.sent();
                    data = docData.data();
                    if (data) {
                        return [2 /*return*/, data];
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, {
                        type: evalType,
                        name: name,
                        controlIds: [],
                        startDate: '',
                        endDate: '',
                        period: '',
                        closeTime: '',
                        state: Evaluation.EvaluationState.Progress,
                        refEvaluationName: ''
                    }];
            }
        });
    });
}
exports.getBase = getBase;
function getRawBases(evalType) {
    return __awaiter(this, void 0, void 0, function () {
        var targetCollectionName, collectionData, evaluationIds;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    targetCollectionName = Evaluation.getKoEvaluation(evalType);
                    return [4 /*yield*/, firebase.dbService.collection(targetCollectionName).get()];
                case 1:
                    collectionData = _a.sent();
                    evaluationIds = [];
                    collectionData.forEach(function (doc) {
                        evaluationIds.push(doc.id);
                    });
                    return [2 /*return*/, Promise.all(lodash_1.default.map(evaluationIds, function (id) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, getBase(evalType, id)];
                        }); }); }))];
            }
        });
    });
}
function getEvaluationState(evalType, name, controlId) {
    return __awaiter(this, void 0, void 0, function () {
        var collectionName, docRef, docData, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    collectionName = Evaluation.getKoEvaluation(evalType);
                    docRef = firebase.dbService
                        .collection(collectionName)
                        .doc(name)
                        .collection(EvaluationUtils_1.STATE_DOC_NAME)
                        .doc(controlId);
                    return [4 /*yield*/, docRef.get()];
                case 1:
                    docData = _a.sent();
                    data = docData.data();
                    if (!data) {
                        return [2 /*return*/, Promise.reject(new Error("".concat(name, "\uC758 Control(").concat(controlId, ")\uC758 \uC0C1\uD0DC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.")))];
                    }
                    return [2 /*return*/, data];
            }
        });
    });
}
function getContent(evalType, name, controlId) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var collectionName, docRef, docData, data, content;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    collectionName = Evaluation.getKoEvaluation(evalType);
                    docRef = firebase.dbService
                        .collection(collectionName)
                        .doc(name)
                        .collection(EvaluationUtils_1.CONTENT_DOC_NAME)
                        .doc(controlId);
                    return [4 /*yield*/, docRef.get()];
                case 1:
                    docData = _b.sent();
                    data = docData.data();
                    if (!data) {
                        return [2 /*return*/, Promise.reject(new Error("".concat(name, "\uC758 Control(").concat(controlId, ")\uC758 \uB0B4\uC5ED\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.")))];
                    }
                    // TODO(sangmuk): REMOVE below code after firebase controls updated.
                    lodash_1.default.forEach({
                        'control.processCycleName': 'control.cycleName',
                        'control.processCycleNumber': 'control.cycleNumber',
                        'control.processSubCategoryName': 'control.subCategoryName',
                        'control.processSubCategoryNumber': 'control.subCategoryNumber',
                        'control.processCategoryName': 'control.categoryName',
                        'control.processCategoryNumber': 'control.categoryNumber'
                    }, function (newKey, originalKey) {
                        if (lodash_1.default.has(data, originalKey)) {
                            var value = lodash_1.default.get(data, originalKey);
                            lodash_1.default.set(data, newKey, value);
                            lodash_1.default.unset(data, originalKey);
                        }
                    });
                    content = data;
                    content.control.type = PRC_1.PRCType.control;
                    if (lodash_1.default.has(data, 'control.processCycleName'))
                        content.risk.type = PRC_1.PRCType.risk;
                    if (Evaluation.isOperationEvaluation(content.data)) {
                        lodash_1.default.forEach(content.data.testContents.rowObjectList, function (rowObject) {
                            rowObject[Evaluation.EVIDENCE_KEY] = (0, EvaluationUtils_1.getFileNameWithoutPrefix)(name, controlId, rowObject[Evaluation.EVIDENCE_KEY]);
                        });
                        // NOTE(sangmuk): 모집단 설명이 비어있을 경우 모집단 파일명을 기입한다.
                        if (lodash_1.default.isEmpty(content.data.populationDescription) && content.files.population) {
                            content.data.populationDescription = (_a = content.files.population) === null || _a === void 0 ? void 0 : _a.name;
                        }
                    }
                    return [4 /*yield*/, Promise.all(lodash_1.default.map([content.files.record, content.files.population], function (target) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (target && (!(target === null || target === void 0 ? void 0 : target.name) || (target === null || target === void 0 ? void 0 : target.state) !== BaseFile_1.FileState.OK || target.checked !== true)) {
                                    target.name = '';
                                    target.state = BaseFile_1.FileState.EMPTY;
                                }
                                return [2 /*return*/];
                            });
                        }); }))];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, Promise.all(lodash_1.default.map([content.files.evidence, content.files.extra], function (targets) { return __awaiter(_this, void 0, void 0, function () {
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(targets, function (target, key) { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                if (target &&
                                                    (!(target === null || target === void 0 ? void 0 : target.name) || (target === null || target === void 0 ? void 0 : target.state) !== BaseFile_1.FileState.OK || target.checked !== true)) {
                                                    lodash_1.default.unset(targets, key);
                                                }
                                                return [2 /*return*/];
                                            });
                                        }); }))];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 3:
                    _b.sent();
                    return [2 /*return*/, data];
            }
        });
    });
}
exports.getContent = getContent;
function getItemsByRecord(evalType, evaluationName, controlIds, getItem) {
    return __awaiter(this, void 0, void 0, function () {
        var values;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(controlIds, function (id) { return __awaiter(_this, void 0, void 0, function () {
                        var data;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getItem(evalType, evaluationName, id)];
                                case 1:
                                    data = _a.sent();
                                    if (data) {
                                        return [2 /*return*/, { id: id, data: data }];
                                    }
                                    return [2 /*return*/, undefined];
                            }
                        });
                    }); }))];
                case 1:
                    values = _a.sent();
                    return [2 /*return*/, lodash_1.default.reduce(lodash_1.default.compact(values), function (result, value) {
                            result[value.id] = value.data;
                            return result;
                        }, {})];
            }
        });
    });
}
function getEvaluationStates(evalType, evaluationName) {
    return __awaiter(this, void 0, void 0, function () {
        var base;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBase(evalType, evaluationName)];
                case 1:
                    base = _a.sent();
                    return [4 /*yield*/, getItemsByRecord(evalType, evaluationName, base.controlIds, getEvaluationState)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getEvaluationStates = getEvaluationStates;
function getContentsWithIds(evalType, evaluationName, controlIds) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getItemsByRecord(evalType, evaluationName, controlIds, getContent)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getContentsWithIds = getContentsWithIds;
function getContents(evalType, evaluationName) {
    return __awaiter(this, void 0, void 0, function () {
        var base;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBase(evalType, evaluationName)];
                case 1:
                    base = _a.sent();
                    return [4 /*yield*/, getContentsWithIds(evalType, evaluationName, base.controlIds)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getContents = getContents;
function filterUnrelatedEvaluationIds(evalType, evaluationIds) {
    return __awaiter(this, void 0, void 0, function () {
        var user, closedEvaluations, _a, _b, evaluationStates, relatedEvaluations, bases, referencedEvaluations, _c, _d;
        var _this = this;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, Admin.getOrCreateUser()];
                case 1:
                    user = _e.sent();
                    if (!user) {
                        return [2 /*return*/, {}];
                    }
                    if (!(user.level === Staff_1.Level.WATCHER)) return [3 /*break*/, 3];
                    _b = (_a = lodash_1.default).compact;
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(evaluationIds, function (id) { return __awaiter(_this, void 0, void 0, function () {
                            var base;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, getBase(evalType, id)];
                                    case 1:
                                        base = _a.sent();
                                        if (base.state === Evaluation.EvaluationState.Closed) {
                                            return [2 /*return*/, { id: id, controlIds: base.controlIds }];
                                        }
                                        return [2 /*return*/, undefined];
                                }
                            });
                        }); }))];
                case 2:
                    closedEvaluations = _b.apply(_a, [_e.sent()]);
                    return [2 /*return*/, lodash_1.default.reduce(closedEvaluations, function (result, _a) {
                            var id = _a.id, controlIds = _a.controlIds;
                            result[id] = controlIds;
                            return result;
                        }, {})];
                case 3: return [4 /*yield*/, Promise.all(lodash_1.default.map(evaluationIds, function (id) { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = { id: id };
                                    return [4 /*yield*/, getEvaluationStates(evalType, id)];
                                case 1: return [2 /*return*/, (_a.states = _b.sent(), _a)];
                            }
                        });
                    }); }))];
                case 4:
                    evaluationStates = _e.sent();
                    if (user.level === Staff_1.Level.ADMIN) {
                        return [2 /*return*/, lodash_1.default.reduce(evaluationStates, function (result, _a) {
                                var id = _a.id, states = _a.states;
                                result[id] = lodash_1.default.keys(states);
                                return result;
                            }, {})];
                    }
                    relatedEvaluations = (0, lodash_1.default)(evaluationStates)
                        .map(function (_a) {
                        var id = _a.id, states = _a.states;
                        var relatedStates = lodash_1.default.pickBy(states, function (itemState) { return itemState.owner === user.id || itemState.performer === user.id; });
                        return !lodash_1.default.isEmpty(relatedStates) ? { id: id, controlIds: lodash_1.default.keys(relatedStates) } : undefined;
                    })
                        .compact()
                        .value();
                    return [4 /*yield*/, getRawBases(evalType)];
                case 5:
                    bases = _e.sent();
                    _d = (_c = lodash_1.default).compact;
                    return [4 /*yield*/, Promise.all(lodash_1.default.map(evaluationStates, function (_a) {
                            var id = _a.id;
                            return __awaiter(_this, void 0, void 0, function () {
                                var childEvaluationBases, controlIds, _b;
                                var _this = this;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            childEvaluationBases = lodash_1.default.filter(bases, { refEvaluationName: id });
                                            if (!childEvaluationBases) {
                                                return [2 /*return*/, undefined];
                                            }
                                            _b = lodash_1.default;
                                            return [4 /*yield*/, Promise.all(lodash_1.default.map(childEvaluationBases, function (base) { return __awaiter(_this, void 0, void 0, function () {
                                                    var itemStates;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: return [4 /*yield*/, getEvaluationStates(evalType, base.name)];
                                                            case 1:
                                                                itemStates = _a.sent();
                                                                return [2 /*return*/, lodash_1.default.map(itemStates, function (state, controlId) {
                                                                        if (state.owner === user.id || state.performer === user.id) {
                                                                            return controlId;
                                                                        }
                                                                    })];
                                                        }
                                                    });
                                                }); }))];
                                        case 1:
                                            controlIds = _b.apply(void 0, [_c.sent()])
                                                .flatten()
                                                .compact()
                                                .uniq()
                                                .value();
                                            return [2 /*return*/, { id: id, controlIds: controlIds }];
                                    }
                                });
                            });
                        }))];
                case 6:
                    referencedEvaluations = _d.apply(_c, [_e.sent()]);
                    return [2 /*return*/, lodash_1.default.reduce(lodash_1.default.concat(relatedEvaluations, referencedEvaluations), function (result, _a) {
                            var id = _a.id, controlIds = _a.controlIds;
                            if (lodash_1.default.has(result, id)) {
                                lodash_1.default.forEach(controlIds, function (controlId) {
                                    if (!lodash_1.default.includes(result[id], controlId)) {
                                        result[id].push(controlId);
                                    }
                                });
                            }
                            else {
                                result[id] = controlIds;
                            }
                            return result;
                        }, {})];
            }
        });
    });
}
function getIds(evalType) {
    return __awaiter(this, void 0, void 0, function () {
        var targetCollectionName, collectionData, evaluationIds, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    targetCollectionName = Evaluation.getKoEvaluation(evalType);
                    return [4 /*yield*/, firebase.dbService.collection(targetCollectionName).get()];
                case 1:
                    collectionData = _c.sent();
                    evaluationIds = [];
                    collectionData.forEach(function (doc) {
                        evaluationIds.push(doc.id);
                    });
                    _b = (_a = lodash_1.default).keys;
                    return [4 /*yield*/, filterUnrelatedEvaluationIds(evalType, evaluationIds)];
                case 2: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
            }
        });
    });
}
function getBases(evalType) {
    return __awaiter(this, void 0, void 0, function () {
        var ids;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getIds(evalType)];
                case 1:
                    ids = _a.sent();
                    return [2 /*return*/, Promise.all(lodash_1.default.map(ids, function (id) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            return [2 /*return*/, getBase(evalType, id)];
                        }); }); }))];
            }
        });
    });
}
exports.getBases = getBases;
function getEvaluationItem(evalType, evaluationName, controlId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {
                        type: evalType,
                        controlId: controlId
                    };
                    return [4 /*yield*/, getBase(evalType, evaluationName)];
                case 1:
                    _a.base = _b.sent();
                    return [4 /*yield*/, getEvaluationState(evalType, evaluationName, controlId)];
                case 2:
                    _a.state = _b.sent();
                    return [4 /*yield*/, getContent(evalType, evaluationName, controlId)];
                case 3: return [2 /*return*/, (_a.content = _b.sent(),
                        _a)];
            }
        });
    });
}
exports.getEvaluationItem = getEvaluationItem;
function getEvaluationItems(evalType, evaluationName) {
    return __awaiter(this, void 0, void 0, function () {
        var evaluationNameToControlIds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, filterUnrelatedEvaluationIds(evalType, [evaluationName])];
                case 1:
                    evaluationNameToControlIds = _a.sent();
                    return [4 /*yield*/, getItemsByRecord(evalType, evaluationName, lodash_1.default.get(evaluationNameToControlIds, evaluationName, []), getEvaluationItem)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getEvaluationItems = getEvaluationItems;
function checkEditable(evalType, evaluationName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBase(evalType, evaluationName)];
                case 1: return [4 /*yield*/, (_a.sent()).state];
                case 2: return [2 /*return*/, ((_a.sent()) === Evaluation.EvaluationState.Progress)];
            }
        });
    });
}
exports.checkEditable = checkEditable;
function getCreateDateOfEvaluationItem(type, name, controlId) {
    return __awaiter(this, void 0, void 0, function () {
        var content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getContent(type, name, controlId)];
                case 1:
                    content = _a.sent();
                    return [2 /*return*/, content.data.createDate];
            }
        });
    });
}
exports.getCreateDateOfEvaluationItem = getCreateDateOfEvaluationItem;
//# sourceMappingURL=EvaluationLoader.js.map